import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Link, Outlet, useNavigate } from '@tanstack/react-router';
import { api } from '../lib/api';
import { usd } from '../lib/format';
import { useSession } from '../lib/session';

export function Shell() {
  const session = useSession();
  const credits = useQuery({
    queryKey: ['credits'],
    queryFn: api.credits,
    refetchInterval: 15_000,
  });
  const qc = useQueryClient();
  const nav = useNavigate();
  const logout = async () => {
    await api.logout();
    qc.clear();
    await nav({ to: '/login' });
  };
  const low = (credits.data?.available ?? 0) < 100_000; // < $0.10
  return (
    <div className="shell">
      <header className="topbar">
        <span className="brand">TAH</span>
        <nav>
          <Link to="/workstation" activeProps={{ className: 'active' }}>
            Workstation
          </Link>
          <Link to="/chat" activeProps={{ className: 'active' }}>
            Chat
          </Link>
          <Link to="/jobs" activeProps={{ className: 'active' }}>
            Jobs
          </Link>
          <Link to="/connectors" activeProps={{ className: 'active' }}>
            Connectors
          </Link>
          <Link to="/account" activeProps={{ className: 'active' }}>
            Account
          </Link>
        </nav>
        <span className="grow" />
        {session.data?.recovery && (
          <Link to="/account" className="pill danger" title="an account recovery is pending">
            recovery pending
          </Link>
        )}
        {credits.data && (
          <Link to="/account" className={low ? 'pill danger' : 'pill'} title="available credits">
            {usd(credits.data.available, 2)} available
          </Link>
        )}
        <span className="muted">{session.data?.email}</span>
        <button type="button" className="small" onClick={logout}>
          Sign out
        </button>
      </header>
      <div className="main">
        <Outlet />
      </div>
    </div>
  );
}
